import React, { useContext, useCallback, useEffect } from "react";
import { PatientMapContext } from "../../context/PatientContext/PatientMapContext";
import PatientMapFilters from "./PatientMapComp/Filters/PatientMapFilters";
import PatientMapTabs from "./PatientMapComp/Tabs/PatientMapTabs";
import { Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PatientMap = () => {
  const {
    page, setPage, pageSize,
    memberFullName, setMemberFullName,
    locationId, setLocationId,
    memberType, setMemberType,
    pcpName, setPcpName,
    gender, setGender,
    ageFrom, setAgeFrom,
    ageTo, setAgeTo,
    dateOfBirth, setDateOfBirth,
    filterAdmitted, setFilterAdmitted,
    filterDischarged, setFilterDischarged,
    filterEmergency, setFilterEmergency,
    filterHighRisk, setFilterHighRisk,
    fetchData
  } = useContext(PatientMapContext);

  const navigate = useNavigate();

  const handleApply = useCallback(() => {
    setPage(0);
    fetchData();
  }, [setPage, fetchData]);

  useEffect(() => {
    fetchData();
  }, [page, pageSize]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSelectPatient = useCallback((row) => {
    const cipId = row?.cipId;
    if (!cipId) return;
    navigate(`/patient-detail/${cipId}`, {
      state: { patientRow: row },
    });
  }, [navigate]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Patient Map
      </Typography>

      <PatientMapFilters
        memberFullName={memberFullName} setMemberFullName={setMemberFullName}
        locationId={locationId}         setLocationId={setLocationId}
        memberType={memberType}         setMemberType={setMemberType}
        pcpName={pcpName}               setPcpName={setPcpName}
        gender={gender}                 setGender={setGender}
        ageFrom={ageFrom}               setAgeFrom={setAgeFrom}
        ageTo={ageTo}                   setAgeTo={setAgeTo}
        dateOfBirth={dateOfBirth}       setDateOfBirth={setDateOfBirth}
        filterAdmitted={filterAdmitted}             setFilterAdmitted={setFilterAdmitted}
        filterDischarged={filterDischarged}         setFilterDischarged={setFilterDischarged}
        filterEmergency={filterEmergency}           setFilterEmergency={setFilterEmergency}
        filterHighRisk={filterHighRisk}             setFilterHighRisk={setFilterHighRisk}
        onApply={handleApply}
      />

      <PatientMapTabs onSelectPatient={handleSelectPatient} />
    </Box>
  );
};

export default PatientMap;
